import { render, staticRenderFns } from "./CoinRule.vue?vue&type=template&id=63c42b9c"
import script from "./CoinRule.vue?vue&type=script&lang=js"
export * from "./CoinRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports